<template>
  <a
    class="w-full"
    :class="[
      hasPositionLg ? 'touch:md:justify-start lg:justify-start' : '',
      hasTextCentered ? 'flex flex-row items-center justify-center' : '',
    ]"
    :href="'javascript:' + decryptedMail"
    @click="openMailer(mail)"
  >
    <FaIcon icon-class="fal fa-envelope" classes="mr-xs" />
    <span
      class="whitespace-nowrap"
      :class="[
        isBold ? 'font-bold' : 'font-normal',
        hasWidth ? 'min-w-[150px]' : '',
        hasTextColor,
      ]"
      >{{ mail }}</span
    >
  </a>
</template>
<script lang="ts" setup>
import { linkTo_UnCryptMailto } from '@/helpers/encryptMail';
import FaIcon from '@/components/fa-icon.vue';

const props = defineProps({
  mail: {
    type: String,
    required: true,
  },
  isBold: {
    type: Boolean,
    required: false,
    default: false,
  },
  hasWidth: {
    type: Boolean,
    required: false,
    default: false,
  },
  hasPositionLg: {
    type: Boolean,
    required: false,
    default: false,
  },
  hasTextColor: {
    type: String,
    required: false,
    default: 'text-primary-base',
  },
  hasTextCentered: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const decryptedMail = linkTo_UnCryptMailto(`mailto:${props.mail}`, -13);

function openMailer(mail: string) {
  window.location.href = 'mailto:' + mail;
}
</script>
